module.exports = __webpack_public_path__ + "static/img/kaineng3.6d51fa59.webp";